export default __webpack_public_path__ + "static/media/metaverse-mobile.59169809.mp4";